import React, { useState } from 'react';
import {  Button } from 'carbon-components-react';
import { useNavigate } from "react-router-dom";
import useMsalApi from '../use-msal-api';
import { useDispatch, useSelector } from 'react-redux';
import { updateEnrollments } from '../../redux/actions/enrollments-actions';
import { setAdminSessions } from '../../redux/actions/admin-actions';


const StartOverButton = ()  => {
    const navigate = useNavigate();
    const [callApi] = useMsalApi();
    const enrollments = useSelector(s => s.enrollments);
    const dispatch = useDispatch();
    const admin = useSelector(s => s.admin);

    console.log(admin);

    const startOver = async () => {
        var path = `Enrollments/${enrollments.id}/${enrollments.employee.id}`;
        if(admin.isAdmin){
            path = `Enrollments/${enrollments.id}`
        }
        var results = await callApi(path, "DELETE");
        console.log("Called");
        if(!results.error){
            navigate('/');
            if(admin.isAdmin){
                dispatch(updateEnrollments([]));
                dispatch(setAdminSessions(admin.sessions.filter(s => s.id !== enrollments.id)))
            } else {
                dispatch(updateEnrollments(results));
            }
        }

    }
    
return (
    <>
    <Button kind="ghost" type="button" onClick={startOver} >Start Over</Button>
    </>
    );
}

export default StartOverButton;